import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_pdg_element_import_file_helper_RowInterface {

    // mandatory columns
    category_group:fromDatatype.VarcharDatatypeInterface;
    category_group_02:fromDatatype.VarcharDatatypeInterface;
    category_group_03:fromDatatype.VarcharDatatypeInterface;
    elements: fromDatatype.JsonDatatypeInterface;
    pdg_elements: fromDatatype.JsonDatatypeInterface;


    // other fields
    guid:fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid:fromDatatype.GuidDataFieldInterface;
    short_error_message:fromDatatype.VarcharDatatypeInterface;
    error_stack_trace:fromDatatype.VarcharDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeClass;
    validated:fromDatatype.VarcharDatatypeInterface;
    processed:fromDatatype.VarcharDatatypeInterface;
    applet_guid:fromDatatype.GuidDataFieldInterface;
    module_guid:fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    status:fromDatatype.StatusDataFieldInterface;
    revision:fromDatatype.GuidDataFieldInterface;
    vrsn:fromDatatype.VarcharDatatypeInterface;

    // validation fields
    category_l1_guid:fromDatatype.GuidDataFieldInterface;
    category_l2_guid:fromDatatype.GuidDataFieldInterface;
    category_l3_guid:fromDatatype.GuidDataFieldInterface;
    category_group_l1_guid:fromDatatype.GuidDataFieldInterface;
    category_group_l2_guid:fromDatatype.GuidDataFieldInterface;
    category_group_l3_guid:fromDatatype.GuidDataFieldInterface;
    outlet_size_guid:fromDatatype.GuidDataFieldInterface;
    outlet_type_guid:fromDatatype.GuidDataFieldInterface;

    //valiation error fields
    category_group_l1_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
    category_group_l2_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
    category_group_l3_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
    category_l1_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
    category_l2_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
    category_l3_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
    outlet_size_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
    outlet_type_guid_validation_error:fromDatatype.VarcharDatatypeInterface;

}

export class bl_inv_pdg_element_import_file_helper_RowClass implements bl_inv_pdg_element_import_file_helper_RowInterface {
   // mandatory columns
   category_group:fromDatatype.VarcharDatatypeInterface;
   category_group_02:fromDatatype.VarcharDatatypeInterface;
   category_group_03:fromDatatype.VarcharDatatypeInterface;
   elements: fromDatatype.JsonDatatypeInterface;
   pdg_elements: fromDatatype.JsonDatatypeInterface;


   // other fields
   guid:fromDatatype.GuidDataFieldInterface;
   file_import_hdr_guid:fromDatatype.GuidDataFieldInterface;
   short_error_message:fromDatatype.VarcharDatatypeInterface;
   error_stack_trace:fromDatatype.VarcharDatatypeInterface;
   line_number: fromDatatype.IntegerDatatypeClass;
   validated:fromDatatype.VarcharDatatypeInterface;
   processed:fromDatatype.VarcharDatatypeInterface;
   applet_guid:fromDatatype.GuidDataFieldInterface;
   module_guid:fromDatatype.GuidDataFieldInterface;
   property_json: fromDatatype.JsonDatatypeInterface;
   acl_config: fromDatatype.JsonDatatypeInterface;
   acl_policy: fromDatatype.JsonDatatypeInterface;
   created_date: fromDatatype.TimestampTzDatatypeInterface;
   updated_date: fromDatatype.TimestampTzDatatypeInterface;
   updated_by_subject_guid:fromDatatype.GuidDataFieldInterface;
   created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
   status:fromDatatype.StatusDataFieldInterface;
   revision:fromDatatype.GuidDataFieldInterface;
   vrsn:fromDatatype.VarcharDatatypeInterface;

   // validation fields
   category_l1_guid:fromDatatype.GuidDataFieldInterface;
   category_l2_guid:fromDatatype.GuidDataFieldInterface;
   category_l3_guid:fromDatatype.GuidDataFieldInterface;
   category_group_l1_guid:fromDatatype.GuidDataFieldInterface;
   category_group_l2_guid:fromDatatype.GuidDataFieldInterface;
   category_group_l3_guid:fromDatatype.GuidDataFieldInterface;
   outlet_size_guid:fromDatatype.GuidDataFieldInterface;
   outlet_type_guid:fromDatatype.GuidDataFieldInterface;

   //valiation error fields
   category_group_l1_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
   category_group_l2_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
   category_group_l3_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
   category_l1_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
   category_l2_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
   category_l3_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
   outlet_size_guid_validation_error:fromDatatype.VarcharDatatypeInterface;
   outlet_type_guid_validation_error:fromDatatype.VarcharDatatypeInterface;

}
